import React from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

/**
 * Mapa simples (MapBox) com um único marcador, usado no modal de edição de
 * Polo Gerador. Substitui o antigo SimpleMap (Google Maps).
 *
 * Props:
 *  - lat, lng: coordenadas do polo (números finitos)
 *  - zoom: nível de zoom inicial (padrão 15)
 */
export default class PoloMapbox extends React.Component {

    containerRef = React.createRef();
    map = null;
    marker = null;

    componentDidMount() {
        this.initMap();
    }

    componentDidUpdate(prevProps) {
        if (!this.map) {
            this.initMap();
            return;
        }

        if (prevProps.lat !== this.props.lat || prevProps.lng !== this.props.lng) {
            this.updatePosition();
        }
    }

    componentWillUnmount() {
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
    }

    hasValidCoords() {
        return Number.isFinite(this.props.lat) && Number.isFinite(this.props.lng);
    }

    initMap() {
        const token = window.mapboxApiKey;

        if (!token) {
            console.error('[PoloMapbox] window.mapboxApiKey ausente');
            return;
        }

        if (!this.containerRef.current || !this.hasValidCoords()) {
            return;
        }

        mapboxgl.accessToken = token;

        const lngLat = [this.props.lng, this.props.lat];

        this.map = new mapboxgl.Map({
            container: this.containerRef.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: lngLat,
            zoom: this.props.zoom ?? 15,
        });

        this.map.addControl(new mapboxgl.NavigationControl(), 'top-right');
        this.map.addControl(new mapboxgl.FullscreenControl(), 'top-right');

        this.marker = new mapboxgl.Marker({ color: '#5B7537' })
            .setLngLat(lngLat)
            .addTo(this.map);

        // Dentro do Dialog do PrimeReact o container só ganha dimensões após a
        // animação de abertura; força o recálculo para o mapa não ficar cinza.
        this.map.once('load', () => this.map && this.map.resize());
        this.resizeTimeout = setTimeout(() => this.map && this.map.resize(), 300);
    }

    updatePosition() {
        if (!this.hasValidCoords()) {
            return;
        }

        const lngLat = [this.props.lng, this.props.lat];

        this.map.setCenter(lngLat);

        if (this.marker) {
            this.marker.setLngLat(lngLat);
        }

        this.map.resize();
    }

    render() {
        return (
            <div
                ref={this.containerRef}
                style={{ height: '400px', width: '100%', border: '1px solid #dee2e6' }}
            />
        );
    }
}
